import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bxl-captiveportal',
  templateUrl: 'captiveportal.component.html',
})
export class CaptiveportalComponent implements OnInit {
  initialized = false;
  constructor() { }

  ngOnInit(): void {
    this.initialized = true;
  }
}
